import { ChangeEvent, FC } from 'react';
import { FormControlLabel, FormGroup, useTheme } from '@mui/material';

import { FormattedMessage } from 'react-intl';
import IOSSwitch from '@/components/shared/ios-switch';
import { pxToRem } from '@/theme/typography';

interface CreditCardSwitchInputProps {
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  label: string;
  isLoading?: boolean;
  isChecked?: boolean;
}

export const CreditCardSwitchInput: FC<CreditCardSwitchInputProps> = ({
  handleChange,
  label,
  isLoading = false,
  isChecked = false,
}) => {
  const theme = useTheme();

  return (
    <FormGroup
      id='credit-card-mark-default'
      sx={{
        marginTop: {
          mobile: '20px',
          tablet: pxToRem(28),
        },
        alignItems: 'flex-start',
        '& .MuiFormControlLabel-label': {
          fontSize: '16px',
          color: theme.palette.grey[80],
        },
      }}
    >
      <FormControlLabel
        disabled={isLoading}
        control={
          <IOSSwitch
            isChecked={isChecked}
            isDisabled={isLoading}
            onChange={handleChange}
          />
        }
        label={<FormattedMessage id={label} />}
      />
    </FormGroup>
  );
};
